// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-management {
    width: 80%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
  }
  
  .device-head {
    text-align: center;
    margin-top: 30px;
    font-weight: bold;
  }
  
  .device-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
   
  .search-bar {
    position: relative;
    display: flex;
    align-items: center;
    width: 25%; 
  }
  
  .search-input {
    padding: 10px 15px 10px 40px; 
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
  }
  
  .search-icon {
    position: absolute;
    left : 200px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #1d2adf;
    pointer-events: none; 
  }
  
   
  .search-button {
    background-color: #4CAF50;
    color: white;
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .search-button:hover {
    background-color: #45a049;
  }
  
  .search-button:focus {
    outline: none;
  }
  
  .device-create {
    background-color: #4CAF50;
    color: white;
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    border-radius: 5px;
  }
  
  .device-create:hover {
    background-color: #37a305;
  }
    
  .device-save, .device-update-cancel {
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
    margin-bottom: 10px;
  }
  
  .device-save {
    background-color: #4CAF50;
    color: white;
    padding: 6px 18px;
  }
  
  .device-update-cancel {
    background-color: #f44336;
    color: white;
    padding: 6px 16px;
  }
  
  .device-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  .device-table th,
  .device-table td {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 12px;
  }
  
  .device-table th {
    background-color: #6bf0f0;
    padding:10px;
  }
  
  .device-table tr:nth-child(odd) {
    background-color: #f9f9f9;
  }
  
  .device-table tr:hover {
    background-color: #f1f1f1;
  }
  
  input[type="text"],
  input[type="number"],
  input[type="email"] {
    width: 90%;
    padding: 8px;
    margin: 5px 0;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
  }
  
  .device-create-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .device-modal-content {
    background-color: #fff;
    padding: 8px;
    border-radius: 5px;
    width: 600px;
    max-width: 95%;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
  
  .device-modal-content h3 {
    text-align: center;
  }
  
  .device-modal-content form div {
    display: flex;
  }
  
  .device-modal-content label {
    font-weight: bold;
    margin-right: 10px;
    width: 30%;
  }
  
  .device-modal-content input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 70%;
    box-sizing: border-box;
  }
  
  .device-modal-content button {
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-right: 10px;
  }
  
  .device-create-modal button[type="button"]:last-child {
    background-color: #535553;
  }
  
  .device-create-modal button[type="button"]:last-child:hover {
    background-color: #424242;
  }
  
  .fa-edit {
    color: #4CAF50;
    cursor: pointer;
  }
  
  .fa-trash {
    color: #f44336;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Plants tab/DeviceManagement.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;;;EAGA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;EACtB;;;EAGA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;IAGE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB","sourcesContent":[".device-management {\r\n    width: 80%;\r\n    margin: 0 auto;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  .device-head {\r\n    text-align: center;\r\n    margin-top: 30px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .device-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n  }\r\n  \r\n   \r\n  .search-bar {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 25%; \r\n  }\r\n  \r\n  .search-input {\r\n    padding: 10px 15px 10px 40px; \r\n    font-size: 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    outline: none;\r\n  }\r\n  \r\n  .search-icon {\r\n    position: absolute;\r\n    left : 200px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    font-size: 16px;\r\n    color: #1d2adf;\r\n    pointer-events: none; \r\n  }\r\n  \r\n   \r\n  .search-button {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .search-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .search-button:focus {\r\n    outline: none;\r\n  }\r\n  \r\n  .device-create {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    padding: 8px 16px;\r\n    border: none;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 16px;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .device-create:hover {\r\n    background-color: #37a305;\r\n  }\r\n    \r\n  .device-save, .device-update-cancel {\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: background-color 0.3s ease;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .device-save {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    padding: 6px 18px;\r\n  }\r\n  \r\n  .device-update-cancel {\r\n    background-color: #f44336;\r\n    color: white;\r\n    padding: 6px 16px;\r\n  }\r\n  \r\n  .device-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .device-table th,\r\n  .device-table td {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    padding: 12px;\r\n  }\r\n  \r\n  .device-table th {\r\n    background-color: #6bf0f0;\r\n    padding:10px;\r\n  }\r\n  \r\n  .device-table tr:nth-child(odd) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .device-table tr:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  input[type=\"text\"],\r\n  input[type=\"number\"],\r\n  input[type=\"email\"] {\r\n    width: 90%;\r\n    padding: 8px;\r\n    margin: 5px 0;\r\n    box-sizing: border-box;\r\n    border: 2px solid #ccc;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .device-create-modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .device-modal-content {\r\n    background-color: #fff;\r\n    padding: 8px;\r\n    border-radius: 5px;\r\n    width: 600px;\r\n    max-width: 95%;\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  .device-modal-content h3 {\r\n    text-align: center;\r\n  }\r\n  \r\n  .device-modal-content form div {\r\n    display: flex;\r\n  }\r\n  \r\n  .device-modal-content label {\r\n    font-weight: bold;\r\n    margin-right: 10px;\r\n    width: 30%;\r\n  }\r\n  \r\n  .device-modal-content input {\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    width: 70%;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .device-modal-content button {\r\n    color: white;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .device-create-modal button[type=\"button\"]:last-child {\r\n    background-color: #535553;\r\n  }\r\n  \r\n  .device-create-modal button[type=\"button\"]:last-child:hover {\r\n    background-color: #424242;\r\n  }\r\n  \r\n  .fa-edit {\r\n    color: #4CAF50;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .fa-trash {\r\n    color: #f44336;\r\n    cursor: pointer;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
